<p *ngIf="initializing; else watchTowerEntry">
  {{ 'INITIALIZING' | translate }}
</p>
<ng-template #watchTowerEntry>
  <router-outlet></router-outlet>
</ng-template>
